<script>
    import axios from "axios";
    export let settings;
    export let dataapi;
    export let datanik;
    let apidata = [];
    let showform = false;
    axios
      .get(settings.url + "/sipade/lay_api/" + dataapi + "/" + datanik, {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        apidata = response.data;
        showform = true;
      });
      function openModal(){}
      function fillAlamat(){}
</script>

{#if showform}
<table border="0" width="100%" class="listtable layTemplate" id="NA-layTemplate" style="display: table;">
                    <tbody>
                        {#if apidata.data.ortu.ayah}
                        <tr>
                            <td colspan="3">                                
                                <b class="float-right px-2 rounded-full bg-green-500 text-white">
                                    AYAH
                                </b>
                                <div class="box box-widget">
                                    <div class="box-header with-border">
                                        
                                        <div class="user-block"> 
                                            <span class="text-lg">{apidata.data.ortu.dt_ayah.nm}
                                            </span>
                                            <div class="description overflow">
                                                <b>
                                                    {apidata.data.ortu.dt_ayah.nik}
                                                </b>
                                                <br>
                                                {apidata.data.ortu.dt_ayah.ttl}
                                                <br>
                                                {apidata.data.ortu.dt_ayah.almt} RT.{apidata.data.ortu.dt_ayah.rt} RW.{apidata.data.ortu.dt_ayah.rw}
                                            </div>
                                        </div>
                                        <!-- /.user-block -->
                                        <div class="box-tools">
                                            <span on:click|preventDefault={()=>openModal('sipade','ktp/{apidata.data.ortu.dt_ayah.nik}','RakIT_Modal','ktp')}
                                                 class="btn-box-tool" data-toggle="tooltip"
                                                data-placement="bottom" data-original-title="Pelayanan">
                                                <i class="glyphicon glyphicon-send"></i>
                                            </span>
                                            <a href="#/sipade/kk/{apidata.data.ortu.dt_ayah.nokk}" class="btn-box-tool" data-toggle="tooltip"
                                                data-placement="bottom" title="" data-original-title="Detail Keluarga">
                                                <i class="glyphicon glyphicon-modal-window"></i>
                                            </a>
                                        </div>
                                        <!-- /.box-tools -->
                                    </div>
                                    <div class="box-footer text-right">
                                        <span on:click|preventDefault={()=>openModal('sipade','cek/nik_edit/{apidata.data.ortu.dt_ayah.nik}','RakIT_Modal_Input','pen_edit')}
                                             class="waves-effect pull-left" data-toggle="tooltip"
                                            data-placement="right" title="" data-original-title="Mutasi Data">
                                            <b class="glyphicon glyphicon-edit"></b>
                                        </span>
                                        <span class="badge sts{apidata.data.ortu.dt_ayah.jns}" data-toggle="tooltip" data-placement="top"
                                            title="" data-original-title="{apidata.data.ortu.dt_ayah.label} - {apidata.data.ortu.dt_ayah.td}"
                                            style="font-weight: 400;">
                                            <i class="glyphicon glyphicon-tag">
                                            </i>
                                            {apidata.data.ortu.dt_ayah.st}
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        {:else}
                        <tr>
                            <td colspan="3">
                                <b>Nama Ayah : {apidata.data.ortu.dt_ayah.nm}</b>
                                <div class="alert alert-warning">
                                    Data
                                    <b>
                                        Ayah
                                    </b>
                                    tidak terverifikasi, sistem menyarankan agar anda menghubungi petugas desa untuk melengkapi
                                    <b>
                                        data Ayah
                                    </b>
                                    terlebih dahulu. 
                                </div>
                            </td>
                        </tr>
                        {/if} {#if apidata.data.ortu.ibu}
                        <tr>
                            <td colspan="3">                                
                                <b class="float-right px-2 rounded-full bg-green-500 text-white">
                                    AYAH
                                </b>
                                <div class="box box-widget">
                                    <div class="box-header with-border">
                                        
                                        <div class="user-block"> 
                                            <span class="text-lg">{apidata.data.ortu.dt_ibu.nm}
                                            </span>
                                            <div class="description overflow">
                                                <b>
                                                    {apidata.data.ortu.dt_ibu.nik}
                                                </b>
                                                <br>
                                                {apidata.data.ortu.dt_ibu.ttl}
                                                <br>
                                                {apidata.data.ortu.dt_ibu.almt} RT.{apidata.data.ortu.dt_ibu.rt} RW.{apidata.data.ortu.dt_ibu.rw}
                                            </div>
                                        </div>
                                        <!-- /.user-block -->
                                        <div class="box-tools">
                                            <span on:click|preventDefault={()=>openModal('sipade','ktp/{apidata.data.ortu.dt_ibu.nik}','RakIT_Modal','ktp')}
                                                 class="btn-box-tool" data-toggle="tooltip"
                                                data-placement="bottom" data-original-title="Pelayanan">
                                                <i class="glyphicon glyphicon-send"></i>
                                            </span>
                                            <a href="#/sipade/kk/{apidata.data.ortu.dt_ibu.nokk}" class="btn-box-tool" data-toggle="tooltip"
                                                data-placement="bottom" title="" data-original-title="Detail Keluarga">
                                                <i class="glyphicon glyphicon-modal-window"></i>
                                            </a>
                                        </div>
                                        <!-- /.box-tools -->
                                    </div>
                                    <div class="box-footer text-right">
                                        <span on:click|preventDefault={()=>openModal('sipade','cek/nik_edit/{apidata.data.ortu.dt_ibu.nik}','RakIT_Modal_Input','pen_edit')}
                                             class="waves-effect pull-left" data-toggle="tooltip"
                                            data-placement="right" title="" data-original-title="Mutasi Data">
                                            <b class="glyphicon glyphicon-edit"></b>
                                        </span>
                                        <span class="badge sts{apidata.data.ortu.dt_ibu.jns}" data-toggle="tooltip" data-placement="top"
                                            title="" data-original-title="{apidata.data.ortu.dt_ibu.label} - {apidata.data.ortu.dt_ibu.td}"
                                            style="font-weight: 400;">
                                            <i class="glyphicon glyphicon-tag">
                                            </i>
                                            {apidata.data.ortu.dt_ibu.st}
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        {:else}
                        <tr>
                            <td colspan="3">
                                <b>Nama Ibu : {apidata.data.ortu.dt_ibu.nm}</b>
                                <div class="alert alert-warning">
                                    Data
                                    <b>
                                        Ibu
                                    </b>
                                    tidak terverifikasi, sistem menyarankan agar anda menghubungi petugas desa untuk melengkapi
                                    <b>
                                        data Ibu
                                    </b>
                                    terlebih dahulu. 
                                </div>
                            </td>
                        </tr>
                        {/if}
                        <tr>
                            <td colspan="4">
                                <h4>Calon Pasangan</h4>
                                <table> 
                                    <tbody class="tab-pane p-t-10 " id="manualCalon">
                                        <tr>
                                            <td class="labelform text-right nama">Nama</td>
                                            <td width="0%" class="labelform">:</td>
                                            <td data-title="Nama">
                                                <input name="calon_nama" id="t_nama" value="" type="text" placeholder="Nama Lengkap"
                                                    class="form-input w-full">
                                            </td>
                                        </tr>
                
                                        <tr>
                                            <td class="labelform text-right tempat_lahir">Tempat Lahir</td>
                                            <td class="labelform" width="0">:</td>
                                            <td data-title="Tempat Lahir">
                                                <input name="calon_tempat_lahir" id="t_ttl1" value="" type="text"
                                                    placeholder="Tempat Lahir" class="form-input w-full">
                                            </td>
                                        </tr>
                
                                        <tr>
                                            <td class="labelform text-right t_ttl2">Tanggal Lahir</td>
                                            <td class="labelform" width="0">:</td>
                                            <td data-title="Tanggal Lahir">
                                                <input size="16" id="t_ttl2" name="calon_t_ttl2" maxlength="10" type="date"
                                                    placeholder="Tanggal Lahir" class="form-input w-full">
                                            </td>
                                        </tr>
                
                                        <tr>
                                            <td class="labelform text-right agama">Agama</td>
                                            <td class="labelform" width="0">:</td>
                                            <td data-title="Agama">
                                                <select name="calon_agama" id="t_agama" class="form-select w-full">
                                                    <option value="0" selected="selected">Agama</option>
                                                    <option value="1">Islam</option>
                                                    <option value="2">Kristen</option>
                                                    <option value="3">Katholik</option>
                                                    <option value="4">Hindu</option>
                                                    <option value="5">Budha</option>
                                                    <option value="6">Lainnya</option>
                                                </select>
                                            </td>
                                        </tr>
                
                                        <tr>
                                            <td class="labelform text-right pekerjaan">Pekerjaan</td>
                                            <td class="labelform" width="0">:</td>
                                            <td id="autoPekerjaan" data-title="Pekerjaan">
                                                <select name="calon_pekerjaan" id="t_pekerjaan" class="form-select w-full">
                                                    <option value="0" selected="selected">Pekerjaan</option>
                                                    <option value="1">Belum/Tidak Bekerja</option>
                                                    <option value="2">Mengurus Rumah Tangga</option>
                                                    <option value="3">Pelajar/Mahasiswa</option>
                                                    <option value="4">Pensiunan</option>
                                                    <option value="5">Pegawai Negeri Sipil (PNS)</option>
                                                    <option value="6">Tentara Nasional Indonesia (TNI)</option>
                                                    <option value="7">Kepolisian (POLRI)</option>
                                                    <option value="8">Perdagangan</option>
                                                    <option value="9">Petani/Pekebun</option>
                                                    <option value="10">Peternak</option>
                                                    <option value="11">Nelayan/Perikanan</option>
                                                    <option value="12">Industri</option>
                                                    <option value="13">Konstruksi</option>
                                                    <option value="14">Transportasi</option>
                                                    <option value="15">Karyawan Swasta</option>
                                                    <option value="16">Karyawan BUMN</option>
                                                    <option value="17">Karyawan BUMD</option>
                                                    <option value="18">Karyawan Honorer</option>
                                                    <option value="19">Buruh Harian Lepas</option>
                                                    <option value="20">Buruh Tani/Perkebunan</option>
                                                    <option value="21">Buruh Nelayan/Perikanan</option>
                                                    <option value="22">Buruh Peternakan</option>
                                                    <option value="23">Pembantu Rumah Tangga</option>
                                                    <option value="24">Tukang Cukur</option>
                                                    <option value="25">Tukang Listrik</option>
                                                    <option value="26">Tukang Batu</option>
                                                    <option value="27">Tukang Kayu</option>
                                                    <option value="28">Tukang Sol Sepatu</option>
                                                    <option value="29">Tukang Las/Pandai Besi</option>
                                                    <option value="30">Tukang Jahit</option>
                                                    <option value="31">Tukang Gigi</option>
                                                    <option value="32">Penata Rias</option>
                                                    <option value="33">Penata Busana</option>
                                                    <option value="34">Penata Rambut</option>
                                                    <option value="35">Mekanik</option>
                                                    <option value="36">Seniman</option>
                                                    <option value="37">Tabib</option>
                                                    <option value="38">Paraji</option>
                                                    <option value="39">Perancang Busana</option>
                                                    <option value="40">Penterjemah</option>
                                                    <option value="41">Imam Masjid</option>
                                                    <option value="42">Pendeta</option>
                                                    <option value="43">Pastor</option>
                                                    <option value="44">Wartawan</option>
                                                    <option value="45">Ustadz/Mubaligh</option>
                                                    <option value="46">Juru Masak</option>
                                                    <option value="47">Promotor Acara</option>
                                                    <option value="48">Anggota DPR-RI</option>
                                                    <option value="49">Anggota DPD</option>
                                                    <option value="50">Anggota BPK</option>
                                                    <option value="51">Presiden</option>
                                                    <option value="52">Wakil Presiden</option>
                                                    <option value="53">Anggota Mahkamah Konstitusi</option>
                                                    <option value="54">Anggota Kabinet/Kementrian</option>
                                                    <option value="55">Duta Besar</option>
                                                    <option value="56">Gubernur</option>
                                                    <option value="57">Wakil Gubernur</option>
                                                    <option value="58">Bupati</option>
                                                    <option value="59">Wakil Bupati</option>
                                                    <option value="60">Walikota</option>
                                                    <option value="61">Wakil Walikota</option>
                                                    <option value="62">Anggota DPRD Prop</option>
                                                    <option value="63">Anggota DPRD Kab Kota PROPESI LAIN SELAIN PEGAWAI </option>
                                                    <option value="64">Dosen</option>
                                                    <option value="65">Guru</option>
                                                    <option value="66">Pilot</option>
                                                    <option value="67">Pengacara</option>
                                                    <option value="68">Notaris</option>
                                                    <option value="69">Arsitek</option>
                                                    <option value="70">Akuntan</option>
                                                    <option value="71">Konsultan</option>
                                                    <option value="72">Dokter</option>
                                                    <option value="73">Bidan</option>
                                                    <option value="74">Perawat</option>
                                                    <option value="75">Apoteker</option>
                                                    <option value="76">Psikiater/Psikolog</option>
                                                    <option value="77">Penyiar Televisi</option>
                                                    <option value="78">Penyiar Radio</option>
                                                    <option value="79">Pelaut</option>
                                                    <option value="80">Peneliti</option>
                                                    <option value="81">Sopir</option>
                                                    <option value="82">Pialang</option>
                                                    <option value="83">Paranormal</option>
                                                    <option value="84">Pedagang</option>
                                                    <option value="85">Perangkat Desa</option>
                                                    <option value="86">Kepala Desa</option>
                                                    <option value="87">Biarawati</option>
                                                    <option value="88">Wiraswasta</option>
                                                    <option value="89">Lainnya</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="labelform text-right desa_luar">Desa</td>
                                            <td class="labelform" width="0">:</td>
                                            <td data-title="Desa">
                                                <input id="t_desa_luar" value="-" type="text" placeholder="Desa" class="form-input w-full  luarInput"
                                                    onclick="openModal('sipade','0','RakIT_Modal_Input_pick','pick_desa')" readonly="">
                                                <input name="calon_desa_luar" id="t_kode_desa_luar" value="-" type="text"
                                                    placeholder="Kode" class="form-input w-full luarInput" readonly="">
                                                    <span on:click|preventDefault={()=>openModal('sipade','0','RakIT_Modal_Input_pick','pick_desa')}
                                                     data-toggle="tooltip" data-placement="top" title=""
                                                    data-original-title="Telusur Desa" class="btn btn-xs btn-warning" style="
                                                    display: table-cell;
                                                    ">Ambil Desa</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="labelform text-right alamat_rt alamat_rw">RT/RW</td>
                                            <td class="labelform" width="0">:</td>
                                            <td data-title="RT/RW">
                                                <input type="number" name="calon_alamat_rt"
                                                    onkeypress="if(this.value.length==2) return false;" pattern="[0-9]*"
                                                    inputmode="numeric" class="form-input lg:w-1/6 w-1/2" maxlength="2" min="1" placeholder="RT">
                                                <span class="labelform">/</span>
                                                <input name="calon_alamat_rw" type="number"
                                                    onkeypress="if(this.value.length==2) return false;" pattern="[0-9]*"
                                                    inputmode="numeric" class="form-input  lg:w-1/6 w-1/2" maxlength="2" min="1" placeholder="RW">
                                            </td>
                                        </tr>
                
                                        <tr>
                                            <td class="labelform text-right alamat">Kampung</td>
                                            <td class="labelform" width="0">:</td>
                                            <td data-title="Kampung">
                                                <input name="calon_alamat" id="t_alamat" value="" type="text" placeholder="Kampung"
                                                    class="form-input w-full">
                                                    <span on:click|preventDefault={()=>fillAlamat(('input[name=alamat_rt]').val(), ('input[name=alamat_rw]').val(), 't_alamat')} class="pull-right" 
                                                    data-toggle="tooltip" data-placement="top"
                                                    data-original-title="Ambil Alamat dari Kombinasi  RT/RW"><i
                                                        class="glyphicon glyphicon-check m-t-0 m-b-0"></i></span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="labelform text-right kewarganegaraan">Warga Negara</td>
                                            <td width="1%" class="labelform">:</td>
                                            <td data-title="Warga Negara">
                                                <select name="calon_kewarganegaraan" id="t_kewarganegaraan" class="form-select w-full">
                                                    <option value="" selected="">Kewarganegaraan</option>
                                                    <option value="1">WNI</option>
                                                    <option value="2">WNA</option>
                                                </select>
                                            </td>
                                        </tr>
                
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                
                    </tbody>
                </table>
                {/if}